import { isMobile } from "@modules/util/device"
import { BreakpointName, addBreakpointListener, getCurrentBreakpoint } from "@modules/util/responsive"
import { fetchAffiliateAdverts, getAffiliateAdverts, setAffiliateAdverts } from "./affiliates"
import { advertCardsContainerElement } from "./dom"
import { getAdvertsCardType } from "./get-advert-card-view-type"

let lastFilledCardElements: Array<HTMLElement> = []
const advertCardList = () =>
    Array.from(advertCardsContainerElement()?.querySelectorAll<HTMLElement>(".ladies-card") || [])
const lastCardIsPremium = (cardList: Array<HTMLElement>) =>
    cardList[cardList.length - 1]?.className.includes("premium") || false

function requiredCardCount(cardList: Array<HTMLElement>, activeBreakpoint: string) {
    const usePremiumAmount = lastCardIsPremium(cardList)
    let cardsPerLineAmount = 0

    switch (activeBreakpoint) {
        case BreakpointName.Large:
            if (getAdvertsCardType() === "list") {
                cardsPerLineAmount = usePremiumAmount ? 2 : 3
            } else {
                cardsPerLineAmount = usePremiumAmount ? 4 : 5
            }
            break

        case BreakpointName.Medium:
        case BreakpointName.Small:
            if (getAdvertsCardType() === "list") {
                cardsPerLineAmount = usePremiumAmount ? 1 : 2
            } else {
                cardsPerLineAmount = usePremiumAmount ? 3 : 4
            }
            break

        default:
            break
    }

    return cardsPerLineAmount
}

function calculateFillAmount(activeBreakpoint: string) {
    const cardList = advertCardList()
    const cardsPerLineAmount = requiredCardCount(cardList, activeBreakpoint)
    let fillAmount = cardsPerLineAmount

    const currentLastElements = Array.from(cardList).slice(-cardsPerLineAmount).toReversed() as Array<HTMLElement>
    const lastLineTopPosition: number = currentLastElements[0]?.getBoundingClientRect().top || 0

    for (const element of currentLastElements) {
        if (element.getBoundingClientRect().top !== lastLineTopPosition) {
            return fillAmount
        }

        --fillAmount
    }

    return 0
}

function removeLastFilledCards() {
    for (const element of lastFilledCardElements) {
        element.remove()
    }
    lastFilledCardElements = []
}

export async function fillMissingCards(activeBreakpoint?: string) {
    if (userData.hasAdFree) return

    await new Promise((resolve) => setTimeout(resolve, 0))

    const currentActiveBreakpoint = activeBreakpoint || getCurrentBreakpoint()

    if (isMobile()) {
        return
    }

    if (SiteInfo.endsWithLastAdvertInGroup) {
        return
    }

    const fillAmount = calculateFillAmount(currentActiveBreakpoint)
    let affiliateAdverts = getAffiliateAdverts()

    if (!affiliateAdverts || affiliateAdverts?.content.length < fillAmount) {
        setAffiliateAdverts(await fetchAffiliateAdverts())
        affiliateAdverts = getAffiliateAdverts()
    }

    if (!affiliateAdverts?.content.length) {
        return
    }

    const usePremiumCards = lastCardIsPremium(advertCardList())
    const randomAffiliates = Array.from(affiliateAdverts.content)
        .sort(() => Math.random() - 0.5)
        .slice(0, fillAmount)

    const parser = new DOMParser()
    lastFilledCardElements = randomAffiliates.map(
        (affiliate) =>
            parser
                .parseFromString(affiliate[usePremiumCards ? "premium" : "standard"], "text/html")
                .querySelector(".ladies-card") as HTMLElement,
    )

    advertCardsContainerElement()?.append(...lastFilledCardElements)
}

addBreakpointListener((activeBreakpoint: string) => {
    if (lastFilledCardElements.length > 0) {
        removeLastFilledCards()
    }

    fillMissingCards(activeBreakpoint)
})
